import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import WithAjax from '../../../common/helpers/WithAjax'
import WithNotify from '../../../common/helpers/WithNotify';
import {clearSkillVendorCurrentProfile} from '../../../../actions/pages/skillvendor-page'

class RejectPopup extends Component {
  constructor() {
    super()

    this.rejectProfile = this.rejectProfile.bind(this)
  }

  rejectProfile() {
    let url = 'skillVendors/' + this.props.skillVendorId + '/profiles/' + this.props.profileType + '/reject';
    this.props.ajax.put(url, null, null, () => {
      this.props.clearSkillVendorCurrentProfile();
      this.props.notify('The profile was rejected.');
    })
  }

  render() {
    return (
      <div style={{display: 'inline-block'}}>
        <button
          className="btn btn-primary btn-rounded mx-2"
          type="button"
          onClick={() => { if (window.confirm('Are you sure?')) this.rejectProfile(); }}>
          Reject
        </button>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  skillVendorId: state.skillVendorPage.overview.Id,
  profileType: state.skillVendorPage.currentProfile.ProfileType
})
const mapDispatchToProps = dispatch => ({
  clearSkillVendorCurrentProfile() { dispatch(clearSkillVendorCurrentProfile()) }
})
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(RejectPopup)